@if (configuration.icon) {
<fa-icon [icon]="[configuration.iconPack, configuration.icon]"></fa-icon>
}
{{ configuration.label }}
